import { render, staticRenderFns } from "./df-header.vue?vue&type=template&id=3b6a42b2&scoped=true&"
import script from "./df-header.vue?vue&type=script&lang=js&"
export * from "./df-header.vue?vue&type=script&lang=js&"
import style0 from "./df-header.vue?vue&type=style&index=0&id=3b6a42b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6a42b2",
  null
  
)

export default component.exports